import { StreamActions } from '@hotwired/turbo';

StreamActions.invoke_stimulus = function () {
  const domId = this.getAttribute('dom-id');
  const [controllerName, actionName] = this.getAttribute('invocation').split('#');

  // Get the target element
  const element = document.getElementById(domId);

  // Error out if element wasn't found
  if (!element) {
    console.error(`[invoke_stimulus] Element with id "${domId}" not found`);
    return;
  }

  // Get the controller
  const controller = window.StimulusApp.getControllerForElementAndIdentifier(
    element,
    controllerName
  );

  // Error out if controller wasn't found
  if (!controller) {
    console.error(`[invoke_stimulus] Controller "${controllerName}" not found on element #${domId}`);
    return;
  }

  // Error out if action wasn't found
  if (typeof controller[actionName] !== 'function') {
    console.error(`[invoke_stimulus] Action "${actionName}" not found on controller "${controllerName}"`);
    return;
  }

  // Invoke the action
  controller[actionName]();
};
